import React, { useState, useEffect } from "react";
import CustomCarousel from "../components/CustomCarousel";
import InfoCard from "../components/InfoCard";
import "../styles/variables.css";

const Section7 = ({ contenuti, cards }) => {
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <section className=" position-relative pt-3">
        {contenuti.map((content, index) => {
          const { titolo1, titolo2, descrizione, immaginiAggiuntive } = content;
          return (
            <div
              key={index}
              className="container-fluid d-flex flex-column align-items-center justify-content-start position-relative"
              style={{
                padding: "32px 16px",
                gap: "16px",
              }}
            >

              <div className="title-section text-center">
                <span className={` ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`}>
                  {titolo1}
                </span>
                <span className={`green-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`} >{titolo2}</span>
              </div>

              <div className="container d-flex position-relative">
                <div className="row w-100">
                  <div className="col-12">
                    <p
                      className="custom-text two-column-text"
                      dangerouslySetInnerHTML={{ __html: descrizione }}
                    />
                  </div>
                </div>
              </div>


              {/* Controllo per evitare errori quando slidesData è undefined */}
              {/* <div className="container d-flex position-relative justify-content-center">
              <CustomCarousel
                slides={
                  immaginiAggiuntive?.map((img, index) => (
                    <div key={index}>
                      <img src={img.immagine_path} alt={`Slide ${index + 1}`} />
                    </div>
                  )) 
                }
              />
            </div> */}
            
            </div>
          );
        })}
      </section>
      <section 
      style={{padding:'72px 32px 46px 32px'}}
      className="bg-dark-green position-relative">
        <div className="position-absolute w-100 head-onda reverse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1440 50"
                  preserveAspectRatio="none"
                  className="w-100"
                >
                  <path
                    fill="#fff" // Colore di Bootstrap bg-light
                    d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                  ></path>
                </svg>
              </div>
        <div className="container">
          <div className="row">
            {/* Contenitore per le righe delle card */}
            <div className="container d-flex flex-column">
              {/* Prima riga di 3 card */}
              <div className="row">
                {cards.map((card, index) => {
                  const { titolo, sottotitolo } = card;
                  return (
                    <div key={index} className="col-md-4"   >
                      {/* 3 card per riga senza margini e padding */}
                      <InfoCard superText={titolo} subtitle={sottotitolo} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute w-100 behind-onda-up">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 50"
            preserveAspectRatio="none"
            className="w-100"
          >
            <path
              fill="#fff" // Colore di Bootstrap bg-light
              d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
            ></path>
          </svg>
        </div>
      </section>
    </>
  );
};

export default Section7;
